import React from 'react';
import { Carousel } from 'react-bootstrap';
import { ASSET_URL } from '../../../../env/Configurations';
import './Hero-Banner-With-Title-And-Cta-Preview.scss';

const HeroBannerWithTitleAndCtaPreview = (props) => {
  const { config } = props;
  return (
    <div className='hero-banner-title-cta'>
      {config?.slides?.length && (
        <Carousel controls={false} indicators variant='dark'>
          {config.slides.map((slide, key) => (
            <Carousel.Item key={key}>
              {!slide?.isVideo && (
                <div
                  className={`d-flex align-items-center justify-content-center ${
                    slide?.shadowOverlay ? 'shadowed-img' : ''
                  }`}
                  key={key}
                  style={
                    slide.imgURL
                      ? {
                          backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                          backgroundSize: 'cover',
                          height: '300px',
                          objectFit: 'cover',
                          width: '100%',
                          backgroundRepeat: 'no-repeat',
                        }
                      : {
                          backgroundRepeat: 'no-repeat',
                          height: '300px',
                        }
                  }
                >
                  <div style={slide.imgURL ? { color: 'white' } : { color: 'black' }}>
                    <p className='hero-banne-title-h3'>
                      {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                    </p>
                    <p className='hero-banne-title'>{slide.titleH1 ? slide.titleH1 : 'H1 Title'}</p>
                    {slide.cta.isActive && (
                      <p className='hero-banne-title-cta'>
                        {slide.cta.title ? slide.cta.title : 'CTA'}
                      </p>
                    )}
                  </div>
                </div>
              )}
              {slide?.isVideo && (
                <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                  <div className='video-container'>
                    <video
                      style={{
                        width: '100%',
                        height: '300px',
                        objectFit: 'fill',
                        position: 'relative',
                        top: 0,
                        left: 0,
                      }}
                      autoPlay
                      loop={slide?.loopPlayBack}
                      preload='auto'
                      src={slide?.videoURL}
                      muted
                    />
                    <div className='video-text-wrapper'>
                      <div className='video-text-container'>
                        <p
                          className='title-label-hero-h3'
                          style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                        >
                          {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                        </p>
                      </div>
                      <div className='video-text-container'>
                        <p
                          className='title-label-hero'
                          style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                        >
                          {slide.titleH1 ? slide.titleH1 : 'H1 Title'}
                        </p>
                      </div>
                      <div className='video-text-container'>
                        {slide.cta.isActive && (
                          <p
                            className='title-label-hero-cta'
                            style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                          >
                            {slide.cta.title ? slide.cta.title : 'CTA'}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default HeroBannerWithTitleAndCtaPreview;
